export default "__VITE_ASSET__ChbHbp4D__"